import { useState, useEffect, useRef, useContext } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import Slider from 'react-slick';

import { ReactComponent as Search } from '../../assets/search.svg';
import { ReactComponent as Target } from '../../assets/target.svg';

import RH from '../../assets/client/rh.png';
import CCRNY from '../../assets/client/ccrny.jpg';
import Omega from '../../assets/client/omega.png';

import Banner from '../../assets/home-page/banner.png';
import { ReactComponent as WalkspanLogo } from '../../assets/walkspan-logo.svg';

import { FiArrowLeftCircle } from "react-icons/fi";
import { FiArrowRightCircle } from "react-icons/fi";

import LocationIntel from '../../assets/landing-page/loc-intel.jpg';
import RecoSys from '../../assets/landing-page/reco-sys.jpg';
import NatLang from '../../assets/landing-page/nat-lang.jpg';

import { ReactComponent as HouseHand } from '../../assets/landing-page/impact/house-hand.svg';
import { ReactComponent as HD } from '../../assets/landing-page/impact/high-definition.svg';
import { ReactComponent as Steps } from '../../assets/landing-page/impact/shoe-prints.svg';
import { ReactComponent as Growth } from '../../assets/landing-page/impact/growth-chart-invest.svg';

import { Autocomplete } from '../../utility/Autocomplete';

import { testimonialsData } from '../../constants';

import { scrollToTop } from '../../services';
import Show from '../../utility/Show';

import YouTube from "react-youtube";

const Home2 = () => {
  const { state, actions, dispatch, navigate } = useContext(StoreContext);
  const {} = state;
  let SearchRef = useRef(null);
  let HIWRef = useRef(null);
  let sliderRef = useRef(null);
  const placeholderRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);

  const opts = {
    width: "100%",
    height: "100%",
    playerVars: {
      autoplay: 0,
      mute: 0,
      controls: 0,
      loop: 0,
      rel: 0,
      modestbranding: 1,
      playlist: "DElpjgE3qws",
    },
  };

  const handleEnd = () => {
    setShowPopup(true);
  };

  const replaceWithDashes = (str) => {
    // Replace non-alphanumeric characters with dashes
    let result = str.replace(/[^a-zA-Z0-9]/g, '-');
    // Replace multiple consecutive dashes with a single dash
    result = result.replace(/-+/g, '-');
    // Remove leading and trailing dashes if any
    result = result.replace(/^-|-$/g, '');
    return result;
  };

  const addressClick = async (address) => {
    // const payload = {
    //   email: 'tmttan03@gmail.com',
    //   password: 'Admin12345+',
    // };
    // await actions.handleLogin(payload);
    // const data = await actions.fetchAddressData(address.description, false, true)

    dispatch({ type: 'SET_FROM_LANDING_PAGE', payload: true });
    dispatch({ type: 'SET_IS_ADMIN', payload: true })
    dispatch({ type: 'SET_SHOW_SEARCH_ADDRESS', payload: false });

    // window.location.href = `/explore/?address=${address.description}`;
    navigate(`/explore?address=${address.description}`);
    // dispatch({ type: 'SET_LOADING', payload: true });
    // await actions.fetchAddressData(address);
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          actions.handleLogin();
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          actions.fetchAddressByLatLng(lat, lng, true);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  };

  useEffect(() => {
    const scrollToDemo = () => {
      if (typeof window === 'undefined') return;
      if (window.location.href.includes('#demo') && HIWRef.current) {
        HIWRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    // check on mount
    scrollToDemo();
    // handle future hash changes
    window.addEventListener('hashchange', scrollToDemo);
    return () => window.removeEventListener('hashchange', scrollToDemo);
  }, []);

  const scrollToSearch = () => {
    if (SearchRef.current) {
      SearchRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const HomeBanner = () => {
    const gotoContactUs = () => {
      scrollToTop();
      navigate('/contact-us');
      document.title = 'Contact Us - Walkspan';
    };

    return (
      <div className='home-banner'>
        <Show.When isTrue={true}>
          <img
            ref={placeholderRef}
            className='banner-placeholder'
            src={Banner}
            alt='Loading video...'
          />
          {/* <video autoPlay loop muted playsInline className="absolute top-0 left-0 w-full h-full object-cover">
            <source src={BannerVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video> */}
        </Show.When>
        <div ref={SearchRef} className='max-w-screen-lg'>
          <div className='banner-content '>
            <div className='flex flex-col gap-2 text-3xl lg:text-5xl drop-shadow-2xl font-medium mb-14 [text-shadow:0_2px_4px_rgba(0,0,0,0.7)]'>
              <div>Unlock the power of </div>
              <div className='text-[#f1592a]'>neighborhood intelligence</div>
            </div>
            <div>
              <div className='text-xl md:text-2xl [text-shadow:0_2px_4px_rgba(0,0,0,0.7)]'>
                FIND YOUR NEXT PROPERTY
              </div>
              <div>
                Currently available in New York City only
              </div>
            </div>
            <div className='search-address-input'>
              <div
                onClick={() => getLocation()}
                className='current-location-icon'
              >
                <Target />
              </div>
              <Autocomplete
                className='!text-black text-xl w-full'
                placeholder={'Search an address'}
                onClick={addressClick}
              />
              <div className='modern-search-address-btn'>
                <Search />
              </div>
            </div>
            {/* <div className='features px-4 py-5 mt-4 2xs:m-4 w-full 2xs:max-w-[365px] md:max-w-[850px]'>
              {bannerFeatures.map((feature) => (
                <a href={feature.url} className='item flex flex-col gap-2 px-5 pl-8 py-5 text-left border-l-2 border-white w-full h-full'>
                  <div className='lg:text-xl text-[16px] font-medium 2xs:pl-2 md:p-0'>{feature.title}</div>
                  <div className='text-[14px] 2xs:pl-2 md:p-0'>{feature.description}</div>
                </a>
              ))}
            </div>
            <div className='flex 2xs:flex-col md:flex-row gap-2'>
              <div
                className='req-demo w-auto p-4 text-xl rounded-md cursor-pointer hover:!bg-white hover:text-black flex gap-2 items-center'
                onClick={() => handleShowVideo()}
              >
                <Play className='!h-[20px] w-auto' /> Watch our video
              </div>
              <div
                className='req-demo w-auto p-4 text-xl rounded-md cursor-pointer hover:!bg-white hover:text-black'
                onClick={() => gotoContactUs()}
              >
                Request a Demo
              </div>
            </div> */}
            <div className='absolute bottom-4 text-xl md:text-2xl font-medium'>
              An AI-driven SaaS company for real estate
            </div>
          </div>
        </div>
      </div>
    );
  };

  const OurMission = () => {
    return (
      <div className='w-full flex items-center justify-end px-10 py-20'>
        <div className='relative max-w-screen-xl mx-auto'>
            <WalkspanLogo className='absolute top-[-11rem] md:top-[-7rem] left-[-30rem] md:left-[-27rem] w-auto h-[500px] -z-10' />
            <div className='max-w-[1500px] z-10 !mr-0 !ml-auto'>
              <div className='my-auto text-center md:text-right'>
                <div className='flex flex-col gap-6 max-w-[730px] ml-none md:ml-auto lg:ml-[9rem]'>
                  <div className='text-4xl md:text-6xl'>Our <span className='text-[#f1592a]'>Mission</span></div>
                  <div className='text-2xl text-[#f1592a] max-w-[730px]'>
                    To harness the power of real estate in enhancing the quality
                    of the public realm through neighborhood intelligence.
                  </div>
                  <div className='text-lg max-w-[730px]'>
                    By doing so, we help boost real estate sales while improving clients' quality of life.
                  </div>
                  <div className='text-lg max-w-[730px]'>
                    Our platform elevates the walking experience, reduces carbon emissions, and
                    stimulates local economies through increased foot traffic.
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    )
  };

  const TodaysData = () => {
    return (
      <div className='todays-data-section h-fit md:h-[500px] w-full flex items-center justify-center bg-[#3a3e49] py-16 px-14 z-10'>
        <div className='text-white text-4xl md:text-6xl flex flex-col gap-6 max-w-[785px] z-10'>
          <div className='leading-[3rem] md:leading-[5rem]'>
            With today's 
            <span className='text-[#f1592a]'> data</span> and 
            <span className='text-[#f1592a]'> AI</span>,
            what was impossible then
            is <span className='text-[#f1592a]'>possible now.</span>
          </div>
        </div>
      </div>
    )
  };

  const Technology = () => {
    const technologies = [
      {
        label: "Location Intelligence",
        description: "Analyze precise neighborhood characteristics with our advanced mapping technology.",
        bg: LocationIntel
      },
      {
        label: "Recommendation System",
        description: "Comparing lifestyle essentials and neighborhood vibe across multiple listings increase the likelihood of finding the right property.",
        bg: RecoSys
      },
      {
        label: "Natural Language Processing",
        description: "Process and translate human queries into structured, data-driven insights through natural language AI.",
        bg: NatLang
      }
    ]
    return (
      <div className='w-full py-14 md:py-20 px-10 md:px-16 max-w-screen-xl mx-auto'>
        <div className='font-bold text-left mr-auto text-xl md:text-2xl'>Technology</div>
        <div>
          <div className='flex flex-col items-center gap-4 max-w-[850px] mx-auto'>
            <div className='text-4xl md:text-6xl'>
              Advanced <span className='text-[#f1592a]'>AI-powered</span> neighborhood intelligence
            </div>
            <div className='max-w-[780px]'>
              Walkspan leverages cutting-edge artificial intelligence to transform urban data into meaningful
              insights for real estate professionals and city planners.
            </div>
          </div>
          <div className='flex justify-center gap-5 flex-wrap mt-10 w-full'>
            {technologies.map((tech, index) => (
              <div
                key={index}
                className='relative flex flex-col items-center gap-6 bg-[#3a3e49] py-10 px-4 w-[350px] text-white'
                style={{
                  backgroundImage: `url(${tech.bg})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
                aria-label={tech.label}
              >
                <div className="absolute inset-0 bg-black/50 w-full"></div>
                <div className='text-xl md:text-3xl font-bold z-10'>{tech.label}</div>
                <div className='text-lg md:text-xl max-w-[275px] z-10'>{tech.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  };

  const Features = () => {
    const featuresData = [
      {
        name: 'Single Interface',
        description: 'One-stop solution for exploring and understanding neighborhood potential.'
      },
      {
        name: 'Scoring',
        description: 'Advanced evaluation of lifestyle essentials and neighborhood vibe.'
      },
      {
        name: 'Mapping',
        description: 'Comprehensive display of sidewalk character and lifestyle essentials.'
      },
      {
        name: 'Reporting',
        description: 'Generating deep insights and analytics about neighborhood dynamics.'
      },
      {
        name: 'Recommendation',
        description: 'Recommending neighborhoods through multiple searches.'
      },
    ];

    return (
      <div className="features-section relative h-fit text-white py-20 px-16 bg-[#0f1114]">
        <div className='font-bold text-left mb-2 max-w-screen-lg mx-auto text-xl md:text-2xl'>Features</div>
        <div className='flex flex-col gap-8'>
          <div className='text-4xl md:text-6xl'>
            <div>Comprehensive platform for</div>
            <div className='text-[#f1592a]'>
              neighborhood intelligence
            </div>
          </div>
          <div className='text-xl md:text-2xl'>
            Walkspan provides a holistic approach through our patented technology.
          </div>
        </div>
        <div className="flex items-center justify-center max-w-screen-2xl mx-auto">
          <div className="flex justify-center gap-16 flex-wrap mt-10">
            {featuresData.map((tab, index) => (
              <div
                key={index}
                className="
                  flex flex-col items-center gap-6 bg-[#3a3e49] py-10 px-4 h-[300px] w-[300px] md:h-[350px] md:w-[350px] text-white
                  justify-center transition-all duration-300
                "
              >
                <div className="text-2xl md:text-3xl font-bold">{tab.name}</div>
                <div className="text-xl md:text-2xl max-w-[275px]">{tab.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const Impact = () => {
    const impactData = [
      {
        label: "Paradigm Shift",
        description: "24% increase in property sales through intelligent neighborhood insights.",
        icon: <HouseHand className='h-8 w-auto' />
      },
      {
        label: "Quality of life",
        description: "Enhanced well-being through increased happiness and improved physical and mental health.",
        icon: <HD className='h-8 w-auto' />
      },
      {
        label: "Sustainability",
        description: "50% reduction in carbon footprint by promoting walkable neighborhoods.",
        icon: <Steps className='h-8 w-auto' />
      },
      {
        label: "Economic growth",
        description: "Stimulating local economies through increased pedestrian engagement and foot traffic.",
        icon: <Growth className='h-8 w-auto' />
      },
    ];

    return (
      <div className='impact-section w-full bg-white max-w-screen-2xl mx-auto'>
        <div className='flex flex-col gap-4 text-left pt-16 px-12 md:px-14'>
          <div className='font-bold text-left text-xl md:text-2xl'>Impact</div>
          <div className='text-4xl md:text-6xl text-center md:text-left'>
            <div>Transforming urban walking corridors through</div>
            <div className='text-[#f1592a]'>data-driven insights</div>
          </div>
          <div className='text-xl max-w-[525px] text-center md:text-left'>
            Walkspan delivers measurable improvements across
            multiple urban dimensions.
          </div>
        </div>
        <div className='flex gap-6'>
          <div className='p-12 md:p-16'>
            {impactData.map((impact, index) => (
              <div key={index} className='flex gap-4 mb-8 text-left'>
                <div className='h-[50px] min-w-[50px] flex items-center justify-center bg-[#f1592a]'>
                  {impact.icon}
                </div>
                <div className='flex flex-col'>
                  <div className='text-2xl md:text-3xl font-bold'>{impact.label}</div>
                  <div className='text-lg md:text-xl max-w-[400px]'>{impact.description}</div>
                </div>
              </div>
            ))}
          </div>
          <div className='hidden md:inline impact-image flex-1'>
          </div>
        </div>
      </div>
    )
  };

  const WalkspanWorks = () => {
    return (
      <div
        ref={HIWRef}
        className='relative w-full flex flex-col items-center gap-6 bg-[#f1592a] pt-20 px-6 md:px-16 pb-10 text-center'
      >
        <div className='text-4xl md:text-6xl text-black text-center'>
          How <span className='text-white'>Walkspan</span> Works
        </div>
        <div className='max-w-[750px] text-white text-lg md:text-xl'>
          Leveraging advanced AI and machine learning to transform urban data into actionable insights.
        </div>
        <div className='relative w-full max-w-6xl mx-auto pt-[56.25%] lg:pt-[29.25%] max-h-[600px] h-full'>
          <div className="absolute top-0 left-0 w-full max-h-[600px] h-full">
            <YouTube videoId="DElpjgE3qws" opts={opts} onEnd={handleEnd} className="w-full max-h-[600px] h-full" />
          </div>

          <Show.When isTrue={showPopup}>
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
              <div className="min-w-[350px] flex flex-col items-center bg-white p-6 shadow-xl text-center max-w-sm w-full mx-4">
                <p className="text-xl md:text-2xl mb-4">
                  Ready to try it yourself? Visit our landing page and claim 3 free credits.
                </p>
                <div
                  className='w-fit px-4 py-2 bg-[#f1592a] text-white hover:opacity-90 cursor-pointer'
                  onClick={() => scrollToSearch()}
                >
                  Search an address
                </div>
              </div>
            </div>
          </Show.When>
        </div>
      </div>
    )
  };

  const Clients = () => {
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,   // enable infinite looping
      slidesToShow: 3,
      slidesToScroll: 1, // scroll one slide at a time
      autoplay: false,    // optional - makes it auto-scroll
      autoplaySpeed: 1500, // optional - speed in ms
    };

    return (
      <div className='relative w-full my-10 py-10'>
        <div className='text-4xl md:text-6xl text-[#f1592a] mb-10'>Clients</div>
        <div className='flex flex-col md:flex-row gap-8 justify-center items-center flex-wrap'>
          <div><img src={CCRNY} alt='CCRNY' className='w-auto h-[100px] md:h-[150px] mx-auto' /></div>
          <div><img src={RH} alt='RH' className='w-auto h-[100px] md:h-[150px] mx-auto' /></div>
          <div><img src={Omega} alt='Omega' className='w-auto h-[100px] md:h-[150px] mx-auto' /></div>
        </div>
        {/* <Slider {...settings}>
          <div><img src={CCRNY} alt='CCRNY' className='!max-w-[300px] h-[100px] mx-auto' /></div>
          <div><img src={RH} alt='RH' className='!max-w-[300px] h-[100px] mx-auto' /></div>
          <div><img src={Omega} alt='Omega' className='!max-w-[300px] h-[100px] mx-auto' /></div>
        </Slider> */}
      </div>
    )
  };

  const Testimonials = () => {
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: 'max-h-[fit-content] md:max-h-[400px]',
    };

    // Handler functions for arrows
    const handlePrev = () => {
      if (sliderRef.current) {
        sliderRef.current.slickPrev();
      }
    };

    const handleNext = () => {
      if (sliderRef.current) {
        sliderRef.current.slickNext();
      }
    };

    return (
      <div className='w-full my-10 px-14 md:px-20 pb-20 max-w-screen-2xl mx-auto'>
        <div className='text-4xl md:text-6xl text-[#f1592a] mb-10'>Testimonials</div>
        <div className='relative max-w-screen-xl relative border border-gray-300'>
          <Slider {...settings} ref={sliderRef}>
            {testimonialsData.map((data, index) => (
              <div className='w-full flex flex-col items-center px-10 md:px-20 py-10 md:py-16 mx-auto' key={index}>
                <div className='text-sm md:text-xl mb-8 uppercase leading-normal'>“{data.msg}”</div>
                <div className='flex justify-between'>
                  <div className='flex flex-col md:flex-row items-center md:items-start gap-2 md:gap-4 mx-auto md:mx-0 mb-6 md:mb-0'>
                    <img src={data.img} alt={`testimonila-${index+1}`} className='rounded-full h-[80px] w-[80px]' />
                    <div className='flex flex-col text-center md:text-left justify-center'>
                      <div className='mt-2 font-medium text-lg uppercase'>{data.name}</div>
                      <div className='font-medium text-gray-500 uppercase'>{data.title}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className='absolute bottom-6 md:bottom-24 right-24 md:right-20 flex gap-4 items-center'>
            <FiArrowLeftCircle color='#000000' size={32} onClick={handlePrev} style={{ cursor: 'pointer' }} />
            <FiArrowRightCircle color='#000000' size={32} onClick={handleNext} style={{ cursor: 'pointer' }} />
          </div>
        </div>
      </div>
    )
  };



  return (
    <div className='landing-home-container'>
      {HomeBanner()}
      {OurMission()}
      {TodaysData()}
      {Technology()}
      {Features()}
      {Impact()}
      {WalkspanWorks()}
      {Clients()}
      {Testimonials()}

      {/* {SingleInterface()}
      {Scoring()}
      {Mapping()}
      {Reporting()}
      {Recommendation()} */}

      {/* {Measurements()} */}
      {/* <div className='bg-white py-8 px-10 flex flex-col items-center justify-center'>
        <div className='text-3xl'>CLIENTS</div>
        <div className='flex flex-col md:flex-row gap-8 items-center md:items-end justify-center my-6'>
          <img src={CCRNY} alt='CCRNY' className='!max-w-[300px] h-[100px]' />
          <img src={RH} alt='RH' className='!max-w-[300px] h-[100px]' />
          <img src={Omega} alt='Omega' className='!max-w-[300px] h-[100px]' />
        </div>
      </div>
      {Testimonials()} */}
      {/* {OtherFeatures()} */}
      {/* <main>
        {ImpactStartup()}
        {Partners()}
      </main> */}
    </div>
  );
};

export default Home2;
